import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Button, Tag, Space, Typography, Row, Col } from 'antd';
import { CalendarOutlined, PercentageOutlined } from '@ant-design/icons';
import styles from './ProgramCard.module.scss';
import TypeTag from 'components/typeTag';
import { ReactComponent as HandIcon } from 'assets/icons/handIcon.svg';
import { ReactComponent as PercentageIcon } from 'assets/icons/percentageIcon.svg';
import { ReactComponent as FullCalendarIcon } from 'assets/icons/fullCalendarIcon.svg';

const { Text, Paragraph } = Typography;

export default function ProgramCard({ program, actions, compact }) {
  const {
    id,
    source,
    title,
    description,
    closesInDays, // number | undefined
    sizes = [], // array of strings
    categories = [], // array of strings
    fundingPercentage, //50 – 70%
    fundingAmount, // (10.000€ – 150.000€)
    deadline, // formatted date "28/02/2026"
  } = program || {};

  return (
    <Card hoverable className={styles['program-card']}>
      {/* Header */}
      <div className={styles['program-card-header']}>
        <div className={styles['program-card-header-content']}>
          {/* <TypeTag type={item.type} /> */}
          {source && (
            <Text className={styles['program-card-header-content-source']}>
              {source}
            </Text>
          )}
        </div>
        <div className={styles['program-card-header-content']}>
          <Text className={styles['program-card-header-content-title']}>
            {title}
          </Text>
          {Number.isFinite(closesInDays) && closesInDays > 0 && (
            <Text
              className={styles['program-card-header-content-closesInDays']}
            >
              Λήγει σε {closesInDays} {closesInDays === 1 ? 'μέρα' : 'ημέρες'}
            </Text>
          )}
          {Number.isFinite(closesInDays) && closesInDays <= 0 && (
            <Text
              className={styles['program-card-header-content-closesInDays']}
            >
              Έχει Λήξει
            </Text>
          )}
        </div>
      </div>

      {/* Description */}
      <Paragraph className={styles['program-card-description']}>
        {description}
      </Paragraph>

      {/* Meta */}
      {!!sizes.length && (
        <div style={{ marginTop: 12 }}>
          <div className={styles['program-card-company-size-title']}>
            Μέγεθος Επιχείρησης
          </div>
          <div style={{ marginTop: 12 }}>
            <Space wrap>
              {sizes.map(s => (
                <Tag
                  className={styles['program-card-company-size-tag']}
                  key={s}
                >
                  {s}
                </Tag>
              ))}
            </Space>
          </div>
        </div>
      )}

      {!!categories.length && (
        <div style={{ marginTop: 24 }}>
          <div className={styles['program-card-categories-title']}>
            Κατηγορίες Δαπανών
          </div>
          <div style={{ marginTop: 12 }}>
            <Space wrap>
              {categories.map(c => (
                <Tag className={styles['program-card-categories-tag']} key={c}>
                  {c}
                </Tag>
              ))}
            </Space>
          </div>
        </div>
      )}

      {/* Stats */}
      <div className={styles['program-card-stats']} style={{ marginTop: 24 }}>
        {fundingAmount && (
          <div
            className={`${styles['program-card-stats-item']} ${styles.fundingAmount}`}
          >
            <HandIcon />
            <div className={styles['program-card-stats-details']}>
              <span>Επιδότηση</span>
              <p>{fundingAmount}</p>
            </div>
          </div>
        )}

        {fundingPercentage && (
          <div
            className={`${styles['program-card-stats-item']} ${styles.fundingPercentage}`}
          >
            <PercentageIcon />
            <div className={styles['program-card-stats-details']}>
              <span>Ποσοστό Ενίσχυσης</span>
              <p>{fundingPercentage}</p>
            </div>
          </div>
        )}

        {deadline && (
          <div
            className={`${styles['program-card-stats-item']} ${styles.deadline}`}
          >
            <FullCalendarIcon />
            <div className={styles['program-card-stats-details']}>
              <span>Προθεσμία</span>
              <p>{deadline}</p>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className={styles['footer-btn']}>
        <Button className={styles['btn-more']} type="link">
          <Link to={`/fundingpage/details/${id}`}>Μάθε Περισσότερα</Link>
        </Button>
        {actions}
      </div>
    </Card>
  );
}
